import React from "react";
import PropTypes from "prop-types";
import "./styles.css";

const HeaderRightItem = (props) => {
  const { children } = props;
  return <div>{children}</div>;
};

HeaderRightItem.defaultProps = {
  children: null,
};

HeaderRightItem.propTypes = {
  children: PropTypes.element,
};

export default HeaderRightItem;
